import { useTranslation } from 'react-i18next';

interface DraftProgressCellProps {
  progressPercent?: number;
}

const DraftProgressCell = ({ progressPercent = 0 }: DraftProgressCellProps) => {
  const { t } = useTranslation();
  const safeProgress = Math.min(100, Math.max(0, progressPercent));

  return (
    <div className="min-w-40 space-y-2">
      <div className="h-2 w-full overflow-hidden rounded-full bg-blue-100">
        <div
          className="h-full rounded-full bg-selise-blue-500"
          style={{ width: `${safeProgress}%` }}
        />
      </div>
      <p className="text-sm text-[hsl(var(--fg))]">
        {t('ORGCONTRACTS_PROGRESS_COMPLETED', { value: safeProgress })}
      </p>
    </div>
  );
};

export default DraftProgressCell;
